import React, { useState, useRef, useEffect } from 'react';
import DashboardLayout from './DashboardLayout';
import ReducedContent from './ReducedContent';
import { Modal, Button, Figure, Alert } from 'react-bootstrap';
import { uploadMultipartForm, fetchOptions } from '../../api/api';
import { useNavigate } from 'react-router-dom';


const ActivityAdd = () => {
  const [subject, setSubject] = useState('');
  const [grade, setGrade] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileForms, setFileForms] = useState([]);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [subjects, setSubjects] = useState([]);
  const [grades, setGrades] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const fileInputRef = useRef(null);
  const formRef = useRef(null);

  const navigate = useNavigate();

  const handleV2 = () => {
    navigate("/dashboard/activity/add/v2");
  };


  useEffect(() => {
    const fetchInitialSubjects = async () => {
      try {
        const options = await fetchOptions(null, null);
        setSubjects(options.subjects || []);
      } catch (error) { }
    };
    fetchInitialSubjects();
  }, []);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      setSelectedFiles(files);
      setFileForms(files.map(() => ({
        materia: '',
        ano: '',
        categoria: '',
        dificuldade: '',
        descricao: '',
        titulo: '',
      })));
      setShowModal(true);
    }
  };

  useEffect(() => {
    fetchGradesForSubject(subject);
  }, [subject]);

  useEffect(() => {
    fetchCategoriesForGrade(subject, grade);
  }, [grade]);

  const handleFormChange = (index, event) => {
    const { name, value } = event.target;
    setFileForms((prevForms) => {
      const newForms = [...prevForms];
      newForms[index] = { ...newForms[index], [name]: value };
      return newForms;
    });
  };

  const fetchGradesForSubject = async (subject) => {
    if (!subject) return;
    try {
      const options = await fetchOptions(subject, null);
      setGrades(options.grades || []);
      setFilteredCategories([]);
    } catch (error) { }
  };

  const fetchCategoriesForGrade = async (subject, grade) => {
    if (!grade) return;
    try {
      const options = await fetchOptions(subject, grade);
      setFilteredCategories(options.categories || []);
    } catch (error) {

    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const form = formRef.current;
    if (!form.checkValidity()) {
      event.stopPropagation();
      form.classList.add('was-validated');
      setShowErrorAlert(true);
      setTimeout(() => setShowErrorAlert(false), 3000);

      const firstInvalid = form.querySelector('input:invalid, select:invalid, textarea:invalid');
      if (firstInvalid) {
        firstInvalid.focus();
      }
      return;
    }

    setIsButtonDisabled(true);

    try {
      for (let i = 0; i < selectedFiles.length; i++) {
        const formData = new FormData();
        formData.append('file', selectedFiles[i]);
        formData.append('subject_uuid', subject);
        formData.append('year', grade);
        formData.append('category_uuid', fileForms[i].categoria);
        formData.append('difficulty', fileForms[i].dificuldade);
        formData.append('description', fileForms[i].descricao);
        formData.append('title', fileForms[i].titulo);
        await uploadMultipartForm(formData);
      }
      setShowSuccessAlert(true);
      setSelectedFiles([]);
      setFileForms([]);
      if (fileInputRef.current) fileInputRef.current.value = '';
      if (formRef.current) formRef.current.classList.remove('was-validated');
    } catch (error) {
      setShowErrorAlert(true);
    }

    setTimeout(() => {
      setShowErrorAlert(false);
      setShowSuccessAlert(false);
    }, 3000);

    setIsButtonDisabled(false);
  };

  return (
    <DashboardLayout title="Adicionar Atividade">
      <ReducedContent>
        {showSuccessAlert && (
          <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible>
            Atividades adicionadas com sucesso!
          </Alert>
        )}
        {showErrorAlert && (
          <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible>
            Erro ao adicionar atividades. Verifique os campos obrigatórios.
          </Alert>
        )}
        <form ref={formRef} className="needs-validation" noValidate onSubmit={handleSubmit}>
          <div className="input-group has-validation mb-2" >
            <span className="input-group-text">Matéria</span>

            <select
              className="form-select"
              name="materia"
              disabled={isButtonDisabled}
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
            >
              <option value="">Matéria</option>
              {subjects.map((subject) => (
                <option key={subject.uuid} value={subject.uuid}>{subject.name}</option>
              ))}
            </select>
            <div className="invalid-feedback">Forneça uma matéria.</div>
          </div>

          <div className="input-group has-validation mb-2" >
            <label className="input-group-text" htmlFor="inputGroupSelect03">Ano</label>

            <select
              className="form-select"
              name="ano"
              disabled={isButtonDisabled}
              value={grade}
              onChange={(e) => setGrade(e.target.value)}
              required
            >
              <option value="">Ano</option>
              {grades.map((grade) => (
                <option key={grade.uuid} value={grade.uuid}>{grade.name}</option>
              ))}
            </select>
            <div className="invalid-feedback">Forneça um ano.</div>
          </div>
          <div className="input-group has-validation mb-3">
            <label className="input-group-text" htmlFor="fileInput">Upload</label>
            <input
              type="file"
              className="form-control"
              id="fileInput"
              multiple
              onChange={handleFileChange}
              ref={fileInputRef}
              required
              disabled={isButtonDisabled}
            />
          </div>
          {selectedFiles.map((file, index) => (
            <div key={index} className="mb-3 border p-3">
              <p><strong>Arquivo:</strong> {file.name}</p>
              <img
                src={file.type === 'application/pdf'
                  ? 'https://repository-activities-test.s3.sa-east-1.amazonaws.com/logos/pdf-logo.jpg'
                  : URL.createObjectURL(file)}
                alt="File preview"
                width={100}
                height={100}
                className="mb-2"
              />

              <div className="input-group has-validation mb-2">
                <span className="input-group-text">Título</span>
                <input
                  className="form-control"
                  aria-label="With textarea"
                  name="titulo"
                  disabled={isButtonDisabled}
                  value={fileForms[index]?.titulo}
                  onChange={(e) => handleFormChange(index, e)}
                  required
                ></input>
                <div className="invalid-feedback">Forneça um título.</div>
              </div>

              <div className="input-group has-validation mb-2" >
                <span className="input-group-text">Descrição</span>
                <textarea

                  disabled={isButtonDisabled}
                  className="form-control"
                  aria-label="With textarea"
                  name="descricao"
                  value={fileForms[index]?.descricao}
                  onChange={(e) => handleFormChange(index, e)}
                  required
                ></textarea>
                <div className="invalid-feedback">
                  Forneça uma descrição.
                </div>
              </div>



              <div className="input-group has-validation mb-2" >
                <label className="input-group-text" htmlFor="inputGroupSelect04">Categoria</label>

                <select
                  className="form-select"
                  name="categoria"
                  disabled={isButtonDisabled}
                  value={fileForms[index]?.categoria || ''}
                  onChange={(e) => handleFormChange(index, e)}
                  required
                >
                  <option value="">Categoria</option>
                  {filteredCategories.map((category) => (
                    <option key={category.uuid} value={category.uuid}>{category.name}</option>
                  ))}
                </select>
                <div className="invalid-feedback">Forneça uma categoria.</div>
              </div>

              <div className="input-group has-validation mb-2">
                <label className="input-group-text" htmlFor="inputGroupSelect05">Nível de dificuldade</label>
                <select
                  disabled={isButtonDisabled}
                  className="form-select"
                  id="inputGroupSelect05"
                  name="dificuldade"
                  value={fileForms[index]?.dificuldade}
                  onChange={(e) => handleFormChange(index, e)}
                  required
                >
                  <option value="" disabled>Escolha...</option>
                  <option value="1">Fácil</option>
                  <option value="2">Médio</option>
                  <option value="3">Difícil</option>
                </select>
                <div className="invalid-feedback">
                  Escolha um nível.
                </div>
              </div>
            </div>
          ))}
          <button className="btn btn-primary" type="submit" disabled={isButtonDisabled}>
            {isButtonDisabled ? 'Processando...' : 'Adicionar'}
          </button>
        </form>
      </ReducedContent>
    </DashboardLayout>
  );
};

export default ActivityAdd;
